
import IpSetList from '@/services/IPSet/Models/IpSetList'
import { Component, Vue } from 'vue-property-decorator'
import { IpSetIP, IpSetListInterface } from '@/services/IPSet/Interfaces'
import IPSetRepository from '@/services/IPSet'
import { DataTableHeader } from 'vuetify'
import IPBanDialog from '@/components/dialogs/ipset/IPBanDialog.vue'

@Component({
  components: {
    'ip-ban-dialog': IPBanDialog,
  },
  inject: ['ipsetRepository'],
})
export default class ViewIPSetList extends Vue {
  public readonly ipsetRepository!: IPSetRepository
  public loading: boolean = true

  public listName: string = ''
  public ipset: IpSetListInterface = {} as IpSetListInterface

  public tableSearch: string = ''
  public ipSearch: string = ''
  public resultsFromCache: boolean = false
  public foundIps: IpSetIP[] = []

  public ipTableHeaders: DataTableHeader[] = [
    { text: 'IP', value: 'ip', sortable: false },
    { text: 'Comment', value: 'comment', sortable: false },
    { text: 'Timeout', value: 'timeout', sortable: true },
    { text: 'Actions', value: 'actions', sortable: false },
  ]

  public ipBanFormDialog: boolean = false

  public async mounted(): Promise<void> {
    this.listName = this.$route.params.setName

    const resp = await this.ipsetRepository.getIpSet(this.listName)
    this.ipset = new IpSetList(
      resp.name,
      resp.type,
      resp.timeoutSupport,
      resp.defaultTimeout,
      resp.commentsSupport,
      resp.counters,
      resp.skbInfo,
      resp.hashSize,
      resp.maxElements,
    )

    if (this.ipset.counters) {
      this.ipTableHeaders.splice(
        3, 0,
        { text: 'Packets', value: 'packets', sortable: false },
        { text: 'Bytes', value: 'bytes', sortable: false },
      )
    }

    this.loading = false
  }

  public async search(): Promise<void> {
    if (this.ipSearch === '*') {
      this.$errorDialog.show('Please be more specific about your search!');
      return;
    }

    try {
      this.foundIps = await this.ipsetRepository.searchIps(this.ipset.name, this.ipSearch, this.resultsFromCache)
    } catch (e) {
      if (e.response.data) {
        this.$errorDialog.show(e.response.data)
      } else {
        this.$errorDialog.show(e.message)
      }
    }
  }

  public async deleteList(): Promise<void> {
    try {
      await this.ipsetRepository.deleteIpSetList(this.listName)
      this.$successDialog.show(`List '${this.listName}' has been deleted`)
    } catch (e) {
      this.$errorDialog.show('Failed to delete list.')
    }
  }

  public async deleteIpFromList(ip: IpSetIP): Promise<void> {
    await this.ipsetRepository.removeIPFromList({
      set: this.listName,
      ip: ip.ip,
    })

    this.foundIps.splice(this.foundIps.indexOf(ip), 1)
  }

  public addIpToList(ip: IpSetIP): void {
    this.foundIps.push(ip);
  }

  public showIPBanDialog(): void {
    this.ipBanFormDialog = true;
  }

  public hideIPBanDialog(): void {
    this.ipBanFormDialog = false;
  }
}
